<template>
  <div class="wrapper">
    <ul>
      <li class="item">
        <div class="item-head">
          <span class="til">大体图影像远程同步参数设置</span>
          <div class="save-btn" @click="save">保存</div>
        </div>
        <ul class="parameter-list">
          <li class="list-item">
            <span class="list-til">IP地址</span>
            <input type="text" v-model="system_set.dt.ip">
          </li>
          <li class="list-item">
            <span class="list-til">端口号</span>
            <input type="text" v-model="system_set.dt.port">
          </li>
          <li class="list-item">
            <span class="list-til">agentName</span>
            <input type="text" v-model="system_set.dt.agentName">
          </li>
        </ul>
      </li>
      <li class="item">
        <div class="item-head">
          <span class="til">皮肤镜影像远程同步参数设置</span>
          <div class="save-btn" @click="save">保存</div>
        </div>
        <ul class="parameter-list">
          <li class="list-item">
            <span class="list-til">IP地址</span>
            <input type="text" v-model="system_set.sk.ip">
          </li>
          <li class="list-item">
            <span class="list-til">端口号</span>
            <input type="text" v-model="system_set.sk.port">
          </li>
          <li class="list-item">
            <span class="list-til">agentName</span>
            <input type="text" v-model="system_set.sk.agentName">
          </li>
        </ul>
      </li>
      <li class="item">
        <div class="item-head">
          <span class="til">CT影像远程同步参数设置</span>
          <div class="save-btn" @click="save">保存</div>
        </div>
        <ul class="parameter-list">
          <li class="list-item">
            <span class="list-til">IP地址</span>
            <input type="text" v-model="system_set.CT.ip">
          </li>
          <li class="list-item">
            <span class="list-til">端口号</span>
            <input type="text" v-model="system_set.CT.port">
          </li>
          <li class="list-item">
            <span class="list-til">agentName</span>
            <input type="text" v-model="system_set.CT.agentName">
          </li>
        </ul>
      </li>
      <li class="item">
        <div class="item-head">
          <span class="til">B超影像远程同步参数设置</span>
          <div class="save-btn" @click="save">保存</div>
        </div>
        <ul class="parameter-list">
          <li class="list-item">
            <span class="list-til">IP地址</span>
            <input type="text" v-model="system_set.B_ultrasonic.ip">
          </li>
          <li class="list-item">
            <span class="list-til">端口号</span>
            <input type="text" v-model="system_set.B_ultrasonic.port">
          </li>
          <li class="list-item">
            <span class="list-til">agentName</span>
            <input type="text" v-model="system_set.B_ultrasonic.agentName">
          </li>
        </ul>
      </li>
      <li class="item">
        <div class="item-head">
          <span class="til">病理影像远程同步参数设置</span>
          <div class="save-btn" @click="save">保存</div>
        </div>
        <ul class="parameter-list">
          <li class="list-item">
            <span class="list-til">IP地址</span>
            <input type="text" v-model="system_set.pathology.ip">
          </li>
          <li class="list-item">
            <span class="list-til">端口号</span>
            <input type="text" v-model="system_set.pathology.port">
          </li>
          <li class="list-item">
            <span class="list-til">agentName</span>
            <input type="text" v-model="system_set.pathology.agentName">
          </li>
        </ul>
      </li>
      <li class="item">
        <div class="item-head">
          <span class="til">美容/治疗影像远程同步参数设置</span>
          <div class="save-btn" @click="save">保存</div>
        </div>
        <ul class="parameter-list">
          <li class="list-item">
            <span class="list-til">IP地址</span>
            <input type="text" v-model="system_set.hairdressing.ip">
          </li>
          <li class="list-item">
            <span class="list-til">端口号</span>
            <input type="text" v-model="system_set.hairdressing.port">
          </li>
          <li class="list-item">
            <span class="list-til">agentName</span>
            <input type="text" v-model="system_set.hairdressing.agentName">
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  export default {
    name: '',
    data() {
      return {
        system_set: {
          dt: {
            ip: '',
            port: ''
          },
          sk: {
            ip: '',
            port: ''
          },
          CT: {
            ip: '',
            port: ''
          },
          B_ultrasonic: {
            ip: '',
            port: ''
          },
          pathology: {
            ip: '',
            port: ''
          },
          hairdressing: {
            ip: '',
            port: ''
          },
        }
      }
    },
    methods: {
      async save() {
        try {
          const id = window.sessionStorage.getItem('me_id');
          const res = await this.$apollo.mutate({
            mutation: gql`mutation(
              $doctor_id: Int!
              $agent_config: String!
            ){
              modifyAgentConfig(
                doctor_id: $doctor_id,
                agent_config: $agent_config
              )
            }`,
            variables: {
              doctor_id: Number(id),
              agent_config: JSON.stringify(this.system_set),
            },
          });
          if (window.localStorage) {
            localStorage.setItem("system_set", JSON.stringify(this.system_set));
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      }
    },
    mounted() {
      if (window.localStorage) {
        // 如果localStorage中有system_set，则取出
        if (localStorage.system_set) {
          const system_set = JSON.parse(localStorage.getItem("system_set"));
          if (system_set.dt) {
            this.system_set.dt = system_set.dt;
          }
          if (system_set.sk) {
            this.system_set.sk = system_set.sk;
          }
          if (system_set.CT) {
            this.system_set.CT = system_set.CT;
          }
          if (system_set.B_ultrasonic) {
            this.system_set.B_ultrasonic = system_set.B_ultrasonic;
          }
          if (system_set.pathology) {
            this.system_set.pathology = system_set.pathology;
          }
          if (system_set.hairdressing) {
            this.system_set.hairdressing = system_set.hairdressing;
          }
        }
      }
    }
  }
</script>


<style lang="less" scoped>
  .wrapper {
    width: 100%;
    height: calc(100% - 40px);
    
    .item {
      margin-top: 20px;
    }
    
    .item-head {
      display: flex;
      height: 36px;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #55a9c6;
      
      .til {
        color: #47a2bf;
        padding-left: 5px;
        font-size: 14px;
        font-weight: bold;
      }
      
      .save-btn {
        width: 80px;
        height: 20px;
        color: #fff;
        border-radius: 5px;
        background-color: #47a2bf;
        text-align: center;
        line-height: 20px;
        font-size: 12px;
        cursor: pointer;
      }
    }
    
    .parameter-list {
      .list-item {
        padding-left: 5px;
        margin-top: 10px;
        
        .list-til {
          display: inline-block;
          width: 100px;
          font-size: 14px;
          font-weight: bold;
        }
        
        input {
          width: 270px;
          height: 30px;
          border: 1px solid #bbb;
          border-radius: 5px;
          text-indent: 10px;
          outline: none;
        }
      }
    }
  }
</style>
